import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
//import Cookies from 'js-cookie';
// modules
import authentication from './authentication';
import app from './app';
import user from './user';
import posts from './posts';
import random from './random';

Vue.use(Vuex);

const namespaced = true;

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    namespaced,
    state: {
        awesome: true,
    },
    modules: {
        authentication,
        user,
        app,
        posts,
        random,
    },
});

export default store;